export default __webpack_public_path__ + "f3e42f934f80634011ce52f20c6c541f.png";